
/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：对菜单数据的订阅工作，全局订阅
 * 更新记录:
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from './sw-http-client.service';
import { SwRouteguardService } from './sw-routeguard.service';
import { SwJwtService } from './sw-jwt.service';
import { GetUserModelService } from './public/get-user-model.service';
import { SwMassageBoxService } from './sw-massage-box.service';
import { SwLoadingmaskService } from '../components/basic-components/sw-loadingmask/sw-loadingmask.service';
import { OninitService } from './oninit.service';
import { SystemIdService } from './public/system-id.service';
import { Router } from '@angular/router';
import { SwSimpleReuseStrategy } from './sw-simplereusestrategy';
import { PlatformLocation } from '@angular/common'
@Injectable()
export class SwMenuService {

  //设置所有模块和菜单信息为全局
  allAreasAndMenusUpdated: Subject<any> = new Subject<any>();
  //将菜单树形设定为全局
  menusTreeUpdated: Subject<any> = new Subject<any>();
  //设置模块全局
  areasUpdated: Subject<any> = new Subject<any>();
  //初始化菜单结果
  valueUpdated: Subject<any> = new Subject<any>();
  //是否编辑状态
  portalStatus: Subject<any> = new Subject<any>();

  staticPortalStatus:boolean;
  //门户组件删除时更新此属性
  deleteWidget: Subject<any> = new Subject<any>();
  //当先选中的项目
  projectUpdated: Subject<any> = new Subject<any>();
  //任何有关是否需要全屏的操作都刷新一下，然后home里面订阅此值决定是都全屏
  isFullScreenUpdated: Subject<any> = new Subject<any>();
  //在单页面模式下，在路由发生变化时，找到面包屑数据
  singleTabUpdated: Subject<any> = new Subject<any>();
  private subjectAreasAndMenus: any; //模块和菜单的数据
  private subjectAreas: any; //模块的数据
  private subjectMenusTree: any; //菜单的树行数据
  isEnUs:boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
  RedirectUrl:string = ''  //项目初始化时分站点部署，点击不同模块进行跳转时携带的首页路径
  SSOQueryParams:any  //项目初始化时分站点部署，点击不同模块进行跳转时携带的参数
  ssoSubjectMenusTree:any = null  //项目初始化时，如果是分站点部署，点击不同模块进行跳转时要发布的侧边栏数据
  constructor(
    private _http: SwHttpClientService,
    private swRouter: SwRouteguardService,
    private user: GetUserModelService,
    private jwt: SwJwtService,
    private router: Router, //路由,
    private init: OninitService,
    public message: SwMassageBoxService,
    private swLoadingmaskService: SwLoadingmaskService,
    private systemId:SystemIdService,
    private Location: PlatformLocation,) {
  }
  
  /**
   * 菜单初始化
   * @param init 是否是登录进来的
   */
  location(init?,SSOFunctionCode?,RedirectUrl?,queryParams?) {
    this.RedirectUrl = this.RedirectUrl || RedirectUrl
    this.SSOQueryParams = this.SSOQueryParams || queryParams
      let currLanguage = this.jwt.getToken('language')
      if(currLanguage == 'en-US'){
        this.isEnUs = true
      }else {
        this.isEnUs = false
      }
    //如果是从登陆进来，或者菜单模块数据没有，则可以执行location中的请求
    if(init=='login' || this.subjectAreas==undefined){
      this.locationMenus(SSOFunctionCode,RedirectUrl,queryParams);
    }else{
      //这里使用定时器是为了防止header中angular变更检测报错：
      setTimeout(() => {
        this.valueUpdated.next(true)
        //将所查询到的 functions --所有的模块和菜单信息全部发布出去，之后工作台快捷菜单需要得到此数据
        this.allAreasAndMenusUpdated.next(this.subjectAreasAndMenus)
        this.init.loca(this.subjectAreas)
        // this.subjectMenusTree = this.subjectAreas[0]
        this.areasUpdated.next(this.subjectAreas); //发布模块数据
        let url = environment.defaultPortal //默认加载第一个模块的工作台
        if(this.RedirectUrl && this.SSOQueryParams){  //如果是分站点点击模块进入的，那么就跳转到指定页面
          if(this.ssoSubjectMenusTree){
            this.menusTreeUpdated.next(this.ssoSubjectMenusTree)
          }
          // this.swRouter.setMenus({ path: this.RedirectUrl, isSelect: true, queryParams: JSON.parse(this.SSOQueryParams) });

        } else {
          this.swRouter.setMenus({ path: url, isSelect: true, queryParams: { Title: this.isEnUs ? "Job Portal":"控制台" } });
        }
      }, 0);
    }
  }

  getImg(){
    this.valueUpdated.next(false)
  }

  /**
   * 加载菜单
   */
  locationMenus(SSOFunctionCode?,RedirectUrl?,queryParams?) {
  //  console.log("执行了init请求------------------------");
    let systemId = this.systemId.getSystemId()
    //获取该用户的初始化菜单数据
    this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}).subscribe(
      data => {
        if (data && data["code"] === 200) {
         
          try {
            
            //判断获取的菜单有没有数据
            if (data["data"]["functions"] == null) {
              this.message.dangerAlert("该用户未分配菜单权限 ，请分配菜单权限！",this.getImg.bind(this));
              //关闭过渡层
              this.swLoadingmaskService.closeLoading();
              //刷新登陆页的验证码
              return;
            }
            if (data["data"]["functions"][0]["children"] == null) {
              this.valueUpdated.next(false)
              this.message.dangerAlert("该用户未分配菜单权限 ，请分配菜单权限！");
              //关闭过渡层
              this.swLoadingmaskService.closeLoading();
              return;
            }
            this.valueUpdated.next(true)  //在login页面订阅此值，为true说明菜单有值，否则登录页重新获取验证码
            //将所查询到的 functions --所有的模块和菜单信息全部发布出去，之后工作台快捷菜单需要得到此数据
            //this.subjectAreasAndMenus 值为 {functionName:'主菜单' , functionId:'xxx' , children:[ {functionName:'业务中心' , functionId:'xxx' , children:[]} ]} 这样的格式，注意业务中心的children都为[]
            this.subjectAreasAndMenus = data["data"]["functions"]  
            this.allAreasAndMenusUpdated.next(this.subjectAreasAndMenus)
            //将用户信息发布出去
            this.user.setUser(data["data"]["user"])
            //存储主岗信息
            this.jwt.setToKen("position", JSON.stringify(data["data"]["position"]))
            //存储单位组织信息
            this.jwt.setToKen("organize", JSON.stringify(data["data"]["organize"]))
            //获取主节点
            var menus = data["data"]["functions"].filter(x => x.parentId == "0")
            //将所有模块(头部一级菜单)的保存到模块参数中
            this.subjectAreas = menus[0]["children"].filter(x => x.isHidden == false);
            this.init.loca(this.subjectAreas)
            //获取tab菜单数据
            //获取当前路由
            let path = this.Location["location"].hash.split('?')[0].split("/");
            //从 路由上确认是否存在 target=_blank ,如果存在，就是新标签页
            let isTargetBlank = this.Location["location"].hash.indexOf('target=_blank') > -1
            //如果path的长度大于等于3 则表示不是从登陆进来的 为刷新浏览器跳转特定路由 或者是 点击一级菜单跳转到不同站点的功能
            if(path.length >= 3 && data["data"]["user"]){
              /* //获取当前模块 例如 oa=>OA
              let areaKey = SSOFunctionCode || path[1].toUpperCase()
              let index = this.subjectAreas.findIndex(item => item.functionCode == areaKey)
              this.subjectMenusTree = this.subjectAreas[index]
              this.subjectAreas[index]['active'] = true  //这里要标注一下，单点登录是要到哪个模块，好让该模块高亮
              if(this.subjectMenusTree){
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank);
              }else{
                this.subjectMenusTree = this.subjectAreas[0]
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank,1);
              } */
              //获取当前模块 例如 oa=>OA
              let areaKey = path[1].toUpperCase()
              this.subjectMenusTree = this.subjectAreas.filter(item => item.functionCode == areaKey)[0]
              if(this.subjectMenusTree){
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank);
              }else{
                this.subjectMenusTree = this.subjectAreas[0]
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank,1);
              }

            }else if(!SSOFunctionCode){
              //如果是从登陆进来，当有默认首页时，就加载默认首页所属的模块，当没有默认首页时，就不加载默认模块
              if(environment.defaultPortal){
                let defaultPortal = environment.defaultPortal
                let urlArr = defaultPortal.split('/')
                let functionCode = urlArr[1].toLocaleUpperCase()
                let activeModel = this.subjectAreas.filter(v=>v.functionCode == functionCode)
                if(activeModel && activeModel.length){
                  
                  //如果默认首页存在所属模块，就默认加载该模块
                  this.subjectMenusTree = activeModel[0]
                  this.setMenusVal(this.subjectMenusTree,false,isTargetBlank,1);
                } else {
                  //如果默认首页不属于任何模块，就没有默认模块
                  // this.menusTreeUpdated.next([]);  //此时侧边栏菜单也没有数据
                  setTimeout(() => {
                    this.subjectMenusTree = {'isFromProtal':false,'isTargetBlank':isTargetBlank,functionCode:null}
                    this.menusTreeUpdated.next(1)
                  }, 0);
                }

              } else {
                //如果没有默认首页，就默认加载第一个模块
                this.subjectMenusTree = this.subjectAreas[0]
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank,1);
              }
            } else if(SSOFunctionCode){
              //单点登录
              SSOFunctionCode = SSOFunctionCode.toLocaleUpperCase()
              let activeModel = this.subjectAreas.filter(v=>v.functionCode == SSOFunctionCode)  //单点登录到哪个模块
              this.subjectMenusTree = activeModel[0]
              if(RedirectUrl){
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank,99,RedirectUrl,queryParams);

              } else {
                this.setMenusVal(this.subjectMenusTree,false,isTargetBlank);
              }
            }
            //this.menusTreeUpdated.next(this.subjectMenusTree); //发布菜单数据
            this.areasUpdated.next(this.subjectAreas); //发布模块数据
            let returnUrl=this.getQueryVariable("url");//回调地址
            let returnParam=this.getQueryVariable("params");//回调地址携带的参数对象

            if(environment.enableSsoLogin && returnUrl){
              //如果启用了sso登录并且携带回调地址，则打开回调地址和参数
              returnUrl= decodeURIComponent(returnUrl);
              let params=null;
              if(returnParam){
                //回调地址参数序列化
                params=JSON.parse(decodeURIComponent(returnParam));
              }
              //这里先把内置对象转化成字符串，不然序列化时无法识别
              if(params["data"]){
                params.data=JSON.stringify(params.data);
              }
              //this.swRouter.setMenus({ path: returnUrl, isSelect: false, queryParams: params });
              this.router.navigate([returnUrl], {
                queryParams:params
              });
              return false
            }else{
              let url = environment.defaultPortal //默认加载第一个模块的工作台
              if(path.length >= 3){
                //刷新浏览器
                this.swRouter.setMenus({ path: url, isSelect: false, queryParams: { Title: this.isEnUs ? "Job Portal":"控制台"} });
              }else {
                //从登录页面
                this.swRouter.setMenus({ path: url, isSelect: true, queryParams: { Title: this.isEnUs ? "Job Portal":"控制台"} });
              }
            }
          } catch (e) {
            throw '获取菜单失败';
          }
        } else if(data && data["code"] === 310){  //用户不存在或者是被禁用,此时刷新系统,后台返回310,前台需要进行提示,并跳转到登陆页面
          // this.message.dangerAlert(data.msg);
          this.router.navigate(['login']); //退到登入
          this.jwt.clear(); //清空浏览器缓存
          SwSimpleReuseStrategy.deleteAllRouteSnapshot(); //删掉所有路由复用
          this.message.danger(data.msg)
        }
      }
    )
  }

  getQueryVariable(variable)
  {
    try{
      var query = window.location.hash.split("?")[1];
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }catch{
      return(false);
    }     
  }
  /**
   * 菜单的递归
   * @param item  查询的节点
   * @param Data  所有菜单的数据
   */
  treeMenus(item, Data) {
    let model: any;
    model = { functionName: item.functionName, functionNameEn: item.functionNameEn, functionId: item.functionId, code: item.functionCode, uri: item.uri, icon: item.icon, children: [] }
    let DataItem = Data.filter(x => x.parentId == item.functionId && x.type == 1 && x.isHidden == false);
    if (DataItem.length == 0) {
      return model;
    }
    for (let i = 0; DataItem.length > i; i++) {
      model.children.push(this.treeMenus(DataItem[i], Data));
    }
    return model;
  }

  /**
 * 菜单的反递归
 * @param item  list数据
 * @param Data 树形数据
 */
  listMenus(item, data) {
    data.forEach(d => {
      item.push({ functionName: d.functionName, functionNameEn: d.functionNameEn, functionId: d.functionId, code: d.functionCode, uri: d.uri, icon: d.icon })
      if (d["children"].length > 0) {
        this.listMenus(item, d["children"])
      }
    });
  }


  /**
   * 选中模块，获取菜单的数据
   * @param areasModel 选中的模块 
   * @param auto 是否加载load界面
   * @param isFromProtal 是否是因为从首页跳转的，默认不是，如果是，那么在刷新侧边栏的时候一定不能打开改模块默认页面，不管环境设置怎么样
   * @param isTargetBlank 是否是打开新标签页
   * @param RedirectUrl 是否是单点登录中的直接点击其他模块菜单，比如 工作门户页面的视觉资产库菜单 
   */
  setMenusVal(areasModel,isFromProtal=false,isTargetBlank=false,auto?,RedirectUrl?,queryParams?) {
    //调用组件里的方法 
    if(auto!=1){
      this.swLoadingmaskService.openLoading();
    }
    //如果是基础平台的话，先从缓存取菜单，没有再去请求
    if(this.jwt.getToken("systemId")=="0546c13470857e36e03f6b2f9ab684d1" && this.jwt.getToken(areasModel.functionCode)){
      let item = { functionName: areasModel.functionName, functionNameEn: areasModel.functionNameEn, functionId: areasModel.functionId, functionCode: areasModel.functionCode, icon: "", uri: "#", parentId: "0", children: JSON.parse(this.jwt.getToken(areasModel.functionCode)) }
      //发布菜单数据
      item['isFromProtal'] = isFromProtal  //看是否是从首页过来的，该参数要跟随侧边栏菜单一起发布出去  
      item['isTargetBlank'] = isTargetBlank  //看是否是打开新标签页，该参数要跟随侧边栏菜单一起发布出去
      this.subjectMenusTree = item;
      auto==1?this.menusTreeUpdated.next(auto):this.menusTreeUpdated.next(this.subjectMenusTree);
      this.swLoadingmaskService.closeLoading();
      return;
    }
    
    //参数 获取该模块下的所有菜单

    //获取当前用户信息
    let user = this.user.getUser();
    //请求加载数据,分两种情况，异步和非异步
    let path=environment.seekerWebAPI + "function/queryFunctionsByUserId?parentId=" + areasModel.functionId +"&lazy=true&depth=1"+
    "&systemId=" + this.systemId.getSystemId() + "&type=1" + "&userId=" + user["userId"];
    //如果是配置或者admin进来，则都获取模块下全部菜单
    if(environment.isLoadAllMenu==true || this.jwt.getToken("systemId")=="0546c13470857e36e03f6b2f9ab684d1"){
       path=environment.seekerWebAPI + "function/queryFunctionsByUserId?parentId=" + areasModel.functionId+
      "&systemId=" + this.systemId.getSystemId() + "&type=1" + "&userId=" + user["userId"];
    }

    this._http.Post(path, {}).subscribe(
        data => {
          if (data["code"] === 200) {
            //将当前模块封装成根节点
            let item = { functionName: areasModel.functionName, functionNameEn: areasModel.functionNameEn, functionId: areasModel.functionId, functionCode: areasModel.functionCode, icon: "", uri: "#", parentId: "0", children: data["data"] }
            //发布菜单数据
            item['isFromProtal'] = isFromProtal  //看是否是从首页过来的，该参数要跟随侧边栏菜单一起发布出去 
            item['isTargetBlank'] = isTargetBlank  //看是否是打开新标签页，该参数要跟随侧边栏菜单一起发布出去
            item['RedirectUrl'] = RedirectUrl //看是否是打开单点登录的其他模块菜单，该参数要跟随侧边栏菜单一起发布出去
            item['queryParams'] = queryParams //单站点打开某个菜单，需要的参数，该参数要跟随侧边栏菜单一起发布出去
            this.subjectMenusTree = item;
            if(item['RedirectUrl']){
              this.ssoSubjectMenusTree = JSON.parse(JSON.stringify(this.subjectMenusTree))
            }
            auto==1?this.menusTreeUpdated.next(auto):this.menusTreeUpdated.next(this.subjectMenusTree);
            this.singleTabUpdated.next(this.subjectMenusTree)  //要更新单页签面包屑
            this.swLoadingmaskService.closeLoading();
            //如果是admin进来，还要把菜单缓存起来
            if(this.jwt.getToken("systemId")=="0546c13470857e36e03f6b2f9ab684d1"){
                this.jwt.setToKen(areasModel.functionCode,JSON.stringify(data["data"]));
            }
          }
        }
      )
  }

    //点击选择模块(传递id,取其下面的菜单值)
    ClickAreas(url,projectId,projectUrl,projectGetParam) {
      let areasModel=JSON.parse(this.jwt.getToken('avtiveAreasModel'));
      if(url && areasModel){
        this._http.Get(url).subscribe(data=>{
          if (data["code"] === 200) {
            //将当前模块封装成根节点
            let item = { functionName: areasModel.functionName, functionNameEn: areasModel.functionNameEn, functionId: areasModel.functionId, functionCode: areasModel.functionCode, icon: "", uri: "#", parentId: "0", children: data["data"] }
            //发布菜单数据
            this.subjectMenusTree = item;
            //此处传递方法名，告诉订阅的地方这是通过这里来的
            this.menusTreeUpdated.next({'clickareas':projectId,"httpInfo":{url:projectUrl,param:projectGetParam}});
            this.swLoadingmaskService.closeLoading();
          }
        })
      }
    }

  //获取所有菜单
  getMenusVal(): any {
    return this.subjectMenusTree;
  }

  //获取所有模块
  getAreasVal(): any {
    return this.subjectAreas;
  }

   //获取初始化结果
   getLocalResult(): any {
    return this.valueUpdated;
  }

  //获取所有模块和菜单
  getAllAreasAndMenus(): any {
    return this.subjectAreasAndMenus;
  }

  //改变状态
  changePortalStatus(status:boolean){
    this.portalStatus.next(status);
  }

    //改变状态
    changeDeleteWidget(widgetId:string){
      this.deleteWidget.next(widgetId);
    }
    //获取
    getStaticPortalStatus(){
      return this.staticPortalStatus;
    }
    //设置
    setStaticPortalStatus(val:boolean){
       this.staticPortalStatus=val;
    }
}


